import axios from 'axios'
import getConfig from 'next/config'

const { publicRuntimeConfig: config } = getConfig()

const api = axios.create({
    baseURL: config.NEXT_PUBLIC_API_GATEWAY_BASEURL,
    withCredentials: true,
})

api.interceptors.request.use(
    (config) => config,
    (error) => Promise.reject(error),
)

api.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error),
)

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        // If api return 401, the user is logged out
        if (error?.response?.status === 401) {
            // In most browsers we have .url, in firefox we have .responseURL
            const url = error.request?.url || error.request?.responseURL || ''
            // Only when the request is not getting the user-info, redirect the user to the root url as it should not be able to access the admin-only pages
            if (!url.includes('/api/account/user-info')) {
                window.location.href = '/'
            }
        } else {
            return Promise.reject(error)
        }
    },
)

export const { get, post, put, delete: destroy } = api
